class Item {
  constructor(name, data) {
    this.name = name;
    this.data = data ? data : {};
    this.type = this.getType();
    this.metadata = this.getMetadata();
    this.image = this.getImage();
    this.video = this.getVideo();
    this.media = this.getMedia();
  }

  getMetadata() {
    if ("Metadata" in this.data) {
      return this.data["Metadata"];
    }
    return [];
  }

  getType() {
    if ("Type" in this.data) {
      return this.data["Type"];
    }
    return "undefined";
  }

  getImage() {
    if ("Image" in this.data) {
      return this.data["Image"];
    }
    return undefined;
  }

  getVideo() {
    if ("Video" in this.data) {
      return this.data["Video"];
    }
    return undefined;
  }

  getMedia() {
    if ("Media" in this.data) {
      return this.data["Media"];
    }
    return undefined;
  }
}

const data = {
  instance: "AOT",
  navbar: {
    brand: {
      name: "Atlas of Torture"
    },
    links: [
      { name: "Home" },
      { name: "About us" },
      { name: "Database" },
      {
        name: "Projects & Activities",
        url:
          "/aot/projects?access_token=pk.eyJ1IjoiZGFuaWNhdGFsYW4iLCJhIjoiY2o4eWVybGJxMXViYjJwcWNyZ3poa3NqcyJ9.mWTnxEb_B2h_x11wdtwFeQ"
      },
      { name: "Learning", url: "/aot/learning" },
      { name: "Exchange" },
      { name: "Contact" }
    ]
  },
  projects: [
    new Item("APT – Association for the Prevention of Torture", {
      Type: {
        name: "Organization",
        color: "#673AB7"
      },
      Metadata: {
        Website: "https://www.apt.ch/",
        Location: "Switzerland, Geneva",
        loc: [[6.1432, 46.2044]]
      }
    }),
    new Item("First Global Meeting of NHRIs with an NPM ManDate", {
      Type: {
        name: "Project/Activity",
        color: "#c570d4"
      },
      Metadata: {
        Description:
          "Around the world, more and more National Human Rights Institutions (NHRIs) are being designated as National Preventive Mechanisms (NPMs), making up more than two thirds of all NPMs worldwide. Although they share – despite their regional and structural diversity – many of the same advantages and challenges in implementing the preventive manDate, they have not yet had an opportunity to discuss NPM issues openly or form a community of practice at the global level. Responding to this gap, APT and the Global Alliance of National Human Rights Institutions (GANRHI) organised the first global meeting for NHRIs as NPMs in March, in the side-lines of the annual GANHRI conference.",
        Location: "Switzerland, Geneva",
        Website:
          "https://www.apt.ch/en/news_on_prevention/first-global-meeting-of-nhris-with-an-npm-manDate/",
        Date: "19 April 2018",
        organisation: "APT, Ganhri",
        loc: [[6.1432, 46.2044]]
      }
    }),
    new Item("Brazil: Harnessing the potential of custody hearings", {
      Type: {
        name: "Project/Activity",
        color: "#c570d4"
      },
      Metadata: {
        Website:
          "https://www.apt.ch/en/news_on_prevention/brazil-harnessing-the-potential-of-custody-hearings/",
        Location: "Rio de Janeiro, Brazil",
        Date: "18 October 2017, 23 October 2018",
        organisation: "APT",
        loc: [[-43.1729, -22.9068]]
      }
    }),
    new Item("Workshop: Monitoring Places of Detention", {
      Type: {
        name: "Project/Activity",
        color: "#c570d4"
      },
      Metadata: {
        Description:
          "Representatives of National human rights institutions from 11 African countries gathered in Kampala, Uganda, for a workshop on how to monitor places of detention.",
        Website:
          "https://www.apt.ch/en/news_on_prevention/new-torture-prevention-ambitions-for-african-nhris/",
        Location: "Uganda",
        Date: "19 - 22 November 2013",
        organisation: "APT",
        loc: [[32.2903, 1.3733]]
      }
    }),
    new Item("Bristol University Human Rights implementation Centre", {
      Type: {
        name: "Organization",
        color: "#673AB7"
      },
      Metadata: {
        Website: "http://www.bris.ac.uk/law/research/centres-themes/hric/",
        Location: "Bristol, United Kingdom",
        loc: [[-2.5879, 51.4545]]
      }
    }),
    new Item("Nigeria OPCAT project", {
      Type: {
        name: "Project/Activity",
        color: "#c570d4"
      },
      Metadata: {
        Description:
          "The overall aim of the HRIC’s Nigeria OPCAT project is to strengthen the operation of the ‘National Preventive Mechanism’ (NPM) established by the government of Nigeria as a State party to the Optional Protocol to the UN Convention against Torture (OPCAT).",
        Website:
          "www.bris.ac.uk/law/research/centres-themes/hric/projects/nigeriaopcatproject/#d.en.278678",
        Location: "Nigeria",
        Date: "2014 – 2016",
        organisation: "Bristol University Human Rights Implementation Centre",
        loc: [[8.6753, 9.082]]
      }
    }),
    new Item(
      "CPT – European Committee for the Prevention of Torture and Inhuman or Degrading Treatment orPunishment, Council of Europe",
      {
        Type: {
          name: "Organization",
          color: "#673AB7"
        },
        Metadata: {
          Website: "https://www.coe.int/en/web/cpt/home",
          Location: "Strasbourg, France",
          loc: [[7.7521, 48.5734]]
        }
      }
    ),
    new Item("Country Visit: Ukraine", {
      Type: {
        name: "Project/Activity",
        color: "#c570d4"
      },
      Metadata: {
        Description:
          "A delegation of the Council of Europe's Committee for the Prevention of Torture and Inhuman or Degrading Treatment or Punishment (CPT) carried out a visit to Ukraine from 8 to 21 December 2017. It was the Committee’s seventh periodic visit to this country.",
        Website:
          "https://www.coe.int/en/web/cpt/-/council-of-europe-anti-torture-committee-visits-ukrai-1",
        Location: "Ukraine",
        Date: "8 – 21 December 2017",
        organisation: "CPT",
        loc: [[31.1656, 48.3794]]
      }
    }),
    new Item("CTI – Convention Against Torture Initiative", {
      Type: {
        name: "Organization",
        color: "#673AB7"
      },
      Metadata: {
        Website: "https://cti2024.org/",
        Location: "Geneva, Switzerland",
        loc: [[6.1432, 46.2044]]
      }
    }),
    new Item(
      "Sharing experiences and building capacity in the Caribbean: The fair administration of justice andthe UN Convention against Torture",
      {
        Type: {
          name: "Project/Activity",
          color: "#c570d4"
        },
        Metadata: {
          Description:
            "This seminar will gather ministers and senior government representatives from sixteen Caribbean UN Member States with a view to exchanging national good practices in the Caribbean and beyond on administering justice and rule of law matters, and to support Caribbean States to overcome technical and capacity constraints that can prevent full engagement with the international human rights system.",
          Website:
            "https://cti2024.org/en/events/cti-regional-event-sharing-experiences-and-building-capacity-in-the-caribbean-the-fair-administration-of-justice-and-the-un-convention-against-torture/",
          Location: "Saint Lucia",
          Date: "4 June 2018 – 6 June 2018",
          organisation: "CTI",
          loc: [[-60.9789, 13.9094]]
        }
      }
    ),
    new Item("Dignity – Danish Institute against Torture", {
      Type: {
        name: "Organization",
        color: "#673AB7"
      },
      Metadata: {
        Website: "https://stoptorture.today/",
        Location: "Copenhagen, Denmark",
        loc: [[9.5018, 56.2639]]
      }
    }),
    new Item("Torture Prevention in Sierra Leone", {
      Type: {
        name: "Project/Activity",
        color: "#c570d4"
      },
      Metadata: {
        Description:
          "Through collaboration with an innovative grass-roots NGO with a regular presence in prisons and police stations and a strong national advocacy profile the project contributes to torture prevention and human rights protection in Sierra Leone",
        Website:
          "https://stoptorture.today/dignitys-work/prevention-of-torture-in-detention/torture-prevention-in-sierra-leone/",
        Location: "Sierra Leone",
        Date: "2016 - ongoing",
        organisation: "Dignity, PWSL",
        loc: [[-11.7799, 8.4606]]
      }
    }),
    new Item("FRA – EU Fundamental Rights Agency", {
      Type: {
        name: "Organization",
        color: "#673AB7"
      },
      Metadata: {
        Website: "http://fra.europa.eu/en",
        Location: "Vienna, Austria",
        loc: [[16.3738, 48.2082]]
      }
    }),
    new Item("IRCT - International Rehabilitation Centre for Torture Victims", {
      Type: {
        name: "Organization",
        color: "#673AB7"
      },
      Metadata: {
        Website: "https://irct.org/",
        Location: "Copenhagen, Denmark",
        loc: [[9.6018, 56.3639]]
      }
    }),
    new Item("Ludwig Boltzmann Institute for Human Rights", {
      Type: {
        name: "Organization",
        color: "#673AB7"
      },
      Metadata: {
        Website: "http://bim.lbg.ac.at/en",
        Location: "Vienna, Austria",
        loc: [[16.3738, 48.2082]]
      }
    }),
    new Item(
      "Strengthening the rights of persons suspected or accused of crime through National Human Rights Institutions",
      {
        Type: {
          name: "Project/Activity",
          color: "#c570d4"
        },
        Metadata: {
          Description:
            "By means of a Baseline Study the Project will provide an overview on the role currently played or that could be played by NHRIs on the protection and promotion of the rights of suspects and accused in criminal proceedings, having specific regard to the different manDates and structures of the NHRIs in the EU.",
          Location: "Vienna/Budapest/Ljubljana/Warsaw",
          Date: "3-2018 - ongoing",
          organisation:
            "Ludwig Boltzmann Institute for Human Rights (+Hungarian Helsinki Committee (Hungary), Helsinki Foundation for Human Rights (Poland), and Peace Institute (Slovenia))",
          loc: [
            [21.0122, 52.2297],
            [14.5058, 46.0569],
            [19.0402, 47.4979],
            [16.3738, 48.2082]
          ]
        }
      }
    ),
    new Item(
      "Enhancing Procedural Rights of Suspected or Accused Persons with Intellectual and/or Psychosocial Disabilities in Criminal Proceedings within the European Union",
      {
        Type: {
          name: "Project/Activity",
          color: "#c570d4"
        },
        Metadata: {
          Description:
            "The project focus lies on strengthening the procedural rights of criminal suspects and accused with intellectual and/or psychosocial disabilities. In line with the Recommendation, the assessment period extends from the moment of suspicion until the verdict. While pre-trial detention will be covered in the project, the situation after the sentencing, i.e. the execution of the prison sentence, will not be covered in this project.",
          Website:
            "http://bim.lbg.ac.at/en/project/current-projects-projects-human-dignity-and-public-security-projects-development-cooperation-and-business/enhancing-procedural-rights-suspected-or-accused-persons-intellectual-andor-psychosocial-disabilities",
          Location: "Vienna (+Sofia, Prague, Ljubljana, Vilnius)",
          Date: "08-2016 - ongoing",
          organisation:
            "Ludwig Boltzmann Institute for Human Rights (+Bulgarian Helsinki Commitee (Bulgaria), League of Human Rights (Czech Republic), Organisation Mental Health Perspectives (Lithuania), Peace Institute (Slovenia))",
          loc: [
            [25.2797, 54.6872],
            [14.4378, 50.0755],
            [23.3219, 42.6977],
            [14.5058, 46.0569],
            [16.3738, 48.2082]
          ]
        }
      }
    ),
    new Item(
      "Strengthening the effective implementation and follow-up of recommendations by torture monitoring bodies in the European Union",
      {
        Type: {
          name: "Project/Activity",
          color: "#c570d4"
        },
        Metadata: {
          Description:
            "his project aimed to strengthen the effective implementation and follow-up of recommendations made by torture monitoring bodies on the national, regional and the international levels by conducting comprehensive research on good practices of follow-up procedures. Furthermore, the project aimed to support and improve coordination between NPMs, the CPT and the SPT through a series of workshops. In addition to the monitoring bodies themselves, the project targeted civil society actors and representatives of EU institutions.",
          Location: "Vienna/Bristol",
          Website:
            "http://bim.lbg.ac.at/en/eu-strengthening-effective-implementation-and-follow-recommendations-torture-monitoring-bodies-european-union",
          Date: "2014-2015",
          organisation:
            "BIM (+ Human Rights Implementation Centre - University of Bristol)",
          loc: [[-2.5879, 51.4545], [16.3738, 48.2082]]
        }
      }
    ),
    new Item(
      "Strengthening the capacities of the National Human Rights Council (Twinning)",
      {
        Type: {
          name: "Project/Activity",
          color: "#c570d4"
        },
        Metadata: {
          Description:
            "During the implementation of the Twinning project, the activities focused on three main fields: , Accompanying the establishment and strengthening the new organizational structure of the CNDH , Strengthening the technical capacities of the members and the administrative staff of the CNDH and its regional human rights commissions , Increasing the visibility of competences and activities of the CNDH and its constituent bodies at a national and international level",
          Website:
            "http://bim.lbg.ac.at/en/project/projects-fundmental-and-human-rights-general-completed-projects-projects-human-dignity-and-public-security-projects-eunip-projects-twinning-eunip/morocco-strengthening-capacities-national-human-rights-council",
          Location: "Morocco",
          Date: "July 2015 – November 2017",
          organisation:
            "Ludwig Boltzmann Institute for Human Rights (+Commission Nationale Consultative des Droits de l’Homme, Center for International Legal Cooperation, Conseil National des Droits de l’Homme)",
          loc: [[-7.0926, 31.7917]]
        }
      }
    ),
    new Item("OMCT – World Organisation Against Torture", {
      Type: {
        name: "Organization",
        color: "#673AB7"
      },
      Metadata: {
        Website: "http://www.omct.org/",
        Location: "Geneva, Switzerland",
        loc: [[6.1432, 46.2044]]
      }
    }),
    new Item(
      "Meeting with NGOs from around the world how to fight torture amid greater threats to human rights",
      {
        Type: {
          name: "Project/Activity",
          color: "#c570d4"
        },
        Metadata: {
          Description:
            "High-ranking officials such as the United Nations High Commissioner for Human Rights, the Director of the European Union’s Fundamental Rights Agency, and the Head of Switzerland’s Human Security Division, as well as some 100 human rights experts, advocacy specialists, and members of OMCT’s SOS-Torture network of NGOs from all over the world exchanged views on issues ranging from the refugee crisis to innovative methods of reporting torture.",
          Website:
            "http://www.omct.org/assistance-to-victims/events/2016/11/d24067/",
          Location: "Geneva, Switzerland",
          Date: "23 September 2014",
          organisation: "OMCT",
          loc: [[6.1432, 46.2044]]
        }
      }
    ),
    new Item("Human Rights Defenders in Cambodia: A Call For Support", {
      Type: {
        name: "Project/Activity",
        color: "#c570d4"
      },
      Metadata: {
        Description:
          "In 2014, human rights defenders in Cambodia continue to be the target of intimidation, arbitrary arrests and spurious criminal charges, particularly when their activism relates to land and labour rights. This side event presented the perspective and outlook of human rights defenders with a view to explore ways for the international community to support the protection of human rights defenders in Cambodia.  During the side event the documentary The Rights of Others was screened.  ",
        Website:
          "http://www.omct.org/human-rights-defenders/events/cambodia/2014/09/d22829/",
        Location: "Geneva, Switzerland",
        Date: "23 September 2014",
        organisation: "OMCT",
        loc: [[6.1432, 46.2044]]
      }
    }),
    new Item("PRI – Penal Reform International", {
      Type: {
        name: "Organization",
        color: "#673AB7"
      },
      Metadata: {
        Website: "https://www.penalreform.org/",
        Location: "London, United Kingdom",
        loc: [[0.1278, 51.5074]]
      }
    }),
    new Item("Development and Use of the Probation System in Bangladesh", {
      Type: {
        name: "Project/Activity",
        color: "#c570d4"
      },
      Metadata: {
        Description:
          "In 2013, PRI and our partner organisation Bangladesh Legal Aid and Services Trust (BLAST) conducted research into the development and use of probation in Bangladesh. Findings and recommendations from the research previously formed the basis of discussions at a seminar on increasing the use of probation in Bangladesh held by PRI and BLAST in Dhaka in December, and now inform this report. The general objective of this study is to identify and analyse the development and use of the probation system within the framework of administration of justice in Bangladesh.",
        Website:
          "https://www.penalreform.org/resource/development-probation-system-bangladesh/",
        Location: "Bangladesh",
        Date: "2013-2014",
        organisation: "PRI",
        loc: [[90.3563, 23.685]]
      }
    }),
    new Item("SPT – UN Subcommittee on the Prevention of Torture", {
      Type: {
        name: "Organization",
        color: "#673AB7",
        Location: "Gineva, Switzerland"
      },
      Metadata: {
        Website: "http://www.ohchr.org/EN/HRBodies/OPCAT/Pages/OPCATIndex.aspx",
        loc: [[6.1432, 46.2044]]
      }
    }),
    new Item("Country visit: Rwanda", {
      Type: {
        name: "Project/Activity",
        color: "#c570d4"
      },
      Metadata: {
        Description:
          "The United Nations Subcommittee on Prevention of Torture (SPT) has suspended a visit to Rwanda on 20 October due to a series of obstructions imposed by authorities, such as accessing some places of detention, confidentiality of certain interviews and over concerns that some interviewees could face reprisals.",
        Website:
          "http://www.ohchr.org/EN/NewsEvents/Pages/DisplayNews.aspx?NewsID=22273&LangID=E",
        Location: "Rwanda",
        Date: "15 – 21 October 2017",
        organisation: "SPT",
        loc: [[29.8739, -1.9403]]
      }
    }),
    new Item("Country visit: Panama", {
      Type: {
        name: "Project/Activity",
        color: "#c570d4"
      },
      Metadata: {
        Description:
          "During its stay in Panama from August 20 to 26, the delegation met with state authorities, the Ombudsman, representatives of civil society and UN agencies.  The SPT visited 13 places of deprivation of liberty in the cities of Panama and Colon. Among others, the SPT visited prisons, police stations, a psychiatric institution, a nursing home for elders as well as juvenile and migrant detention centres.  The delegation conducted private interviews with persons deprived of their liberty, prison officials, police and medical personnel, obtaining solid findings on the situation of persons deprived of their liberty and prison conditions.",
        Website:
          "http://www.ohchr.org/EN/NewsEvents/Pages/DisplayNews.aspx?NewsID=22003&LangID=E",
        Location: "Panama",
        Date: "20 – 26 August 2017",
        organisation: "SPT",
        loc: [[-80.7821, 8.538]]
      }
    }),
    new Item("Country visit: Mongolia", {
      Type: {
        name: "Project/Activity",
        color: "#c570d4"
      },
      Metadata: {
        Description:
          "The United Nations Subcommittee on Prevention of Torture (SPT) is due to make its first visit to Mongolia from 11 to 20 September to assess the treatment of persons deprived of their liberty, as well as the safeguards for their protection against torture and ill-treatment.  Among the places the SPT delegation is due to visit are: prisons, police stations, detention facilities for women and juveniles and psychiatric hospitals. The experts will meet government officials, the National Human Rights Commission of Mongolia, and representatives of civil society to seek ways of strengthening the authorities’ efforts to prevent and eliminate torture or other cruel, inhuman or degrading treatment of detainees.  ",
        Website:
          "http://www.ohchr.org/EN/NewsEvents/Pages/DisplayNews.aspx?NewsID=22033&LangID=E",
        Location: "Mongolia",
        Date: "11 – 20 September 2017",
        organisation: "SPT",
        loc: [[103.8467, 46.8625]]
      }
    })
  ],
  media: [
    new Item("How to stop Torture", {
      Type: { name: "Discussion", color: "#009688" },
      Media: {
        platform: "ted",
        id: "karen_tse_how_to_stop_torture"
      },
      Metadata: {
        Description:
          "Political prisoners aren't the only ones being tortured -- the vast majority of judicial torture happens in ordinary cases, even in 'functioning' legal systems. Social activist Karen Tse shows how we can, and should, stand up and end the use of routine torture.",
        Source: "TED Global 2011",
        "Source Link":
          "https://www.ted.com/talks/karen_tse_how_to_stop_torture",
        People: "Karen Tse",
        Date: 2011,
        Duration: "12:28"
      }
    }),
    new Item("The Role of the Special Rapporteur on Torture", {
      Type: { name: "Presentation", color: "primary" },
      Media: {
        platform: "vimeo",
        id: "61638194"
      },
      Metadata: {
        Description:
          "Manfred Nowak discusses his role as UN Special Rapporteur on Torture.",
        Source: "APT Geneva",
        "Source Link": "https://vimeo.com/album/2299051/video/61638194",
        People: "Manfred Nowak",
        Duration: "04:52"
      }
    }),
    new Item("Nothing can justify torture", {
      Type: { name: "Discussion", color: "#009688" },
      Media: {
        platform: "youtube",
        id: "loBqV8YwcdM"
      },
      Metadata: {
        Description:
          "The HUMAN RIGHTS TALKS take place in cooperation with the Ludwig Boltzmann Institute of Human Rights, derStandard.at, profil online, Zeitschrift Juridikum and zige.tv.",
        Source: "Human Rights Talks",
        "Source Link": "https://www.youtube.com/watch?v=loBqV8YwcdM",
        People:
          "Manfred NOWAK, Gerald STABEROCK, Henri TIPHAGNE, and Edita LINTL",
        Date: 2013,
        Duration: "1:47:21"
      }
    }),
    new Item(
      "Reflections on Four Decades of International Action against Torture",
      {
        Type: { name: "Podcast", color: "#8bc34a" },
        Media: {
          platform: "podcasts.ox.ac.uk",
          id: "3e0633b071d842319411"
        },
        Metadata: {
          Description:
            "Lectures on international law issues by eminent scholars, practitioners and judges of national and international courts. The lecture series is brought to you by the Public International Law Discussion Group, part of the Law Faculty of the University of Oxford, and is supported by the British Branch of the International Law Association and Oxford University Press. Further details can be found on the Public International Law at Oxford ",
          Source:
            "Public International Law Discussion Group (Part 1) & Annual Global Justice",
          "Source Link":
            "https://podcasts.ox.ac.uk/reflections-four-decades-international-action-against-torture",
          People: "Nigel Rodley",
          Date: 2015,
          Duration: "43:50"
        }
      }
    ),
    new Item("Episode 4 – The SHU", {
      Type: { name: "Podcast", color: "#8bc34a" },
      Media: {
        platform: "audio_html",
        id: "3e0633b071d842319411"
      },
      Metadata: {
        Description:
          "The hole, the box, solitary confinement. It doesn’t matter what you call it; doing time in the SHU (Security Housing Unit) means you are alone and segregated from the general prison population. In this episode, four men who served between 8 and 28 years in the SHU share their memories of that time. For further detail please see: https://www.earhustlesq.com/episodes/2017/7/26/the-shu",
        Source: "Ear Hustle Podcast",
        "Source Link": "https://www.earhustlesq.com/episodes/2017/7/26/the-shu",
        Date: 2017,
        Duration: "28:26"
      }
    }),
    new Item("California’s prison gang problem: the role of prison size", {
      Type: { name: "Podcast", color: "#8bc34a" },
      Media: {
        platform: "soundcloud",
        id: "294593381"
      },
      Metadata: {
        Description:
          "In recent decades, there has been a noticeable trend towards larger prisons of 1,000 prisoners plus. In the USA, the trend has been particularly prevalent – with around 3,500 prisoners per prison in California for example, but other countries have followed a similar path. In this expert blog for PRI, David Skarbek, Senior Lecturer in Political Economy at King’s College London, argues that gang rule or ‘extra-legal governance’ in prisons in California can be explained by the prison boom, in particular the growth in the size of prisons in the 1980s. Gangs now provide the order and safety that management can no longer provide. A return to smaller prisons – where staff and prisoners know each other – should be considered",
        Source: "PRI media",
        "Source Link":
          "https://www.penalreform.org/resource/podcast-californias-prison-gang-problem-role-prison-size/",
        Date: 2016,
        People:
          "David Skarbek, Senior Lecturer in Political Economy at King’s College London",
        Duration: "09:35"
      }
    }),
    new Item("Changing Police Mindsets: From Coercion to Justice", {
      Type: { name: "Film", color: "#00bcd4" },
      Media: {
        platform: "vimeo",
        id: "246243040"
      },
      Metadata: {
        Description:
          "Moving away from confession-based criminal justice systems and effectively implementing procedural safeguards immediately upon arrest have been proven to significantly reduce the risks of torture. Produced by the APT in partnership with the Anti-Torture Initiative (ATI), this animation video illustrates the key importance of non-coercive interviewing of suspects and the implementation of safeguards during the first hours of police custody. For further detail please see: https://vimeo.com/246243040.",
        Source: "APT Geneva",
        "Source Link": "https://vimeo.com/246243040",
        Date: 2018,
        Duration: "02:07"
      }
    }),
    new Item("OPCAT – The Torture Prevention Treaty", {
      Type: { name: "Film", color: "#00bcd4" },
      Media: {
        platform: "vimeo",
        id: "170032484"
      },
      Metadata: {
        Description:
          "The Optional Protocol to the UN Convention against Torture - OPCAT - sends a clear message: the risk of torture and other ill-treatment exists in all situations where persons are deprived of their liberty. Therefore, prevention is needed everywhere and at all times. This short video explains what the OPCAT is all about.",
        Source: "APT Geneva",
        "Source Link": "https://vimeo.com/170032484",
        Duration: "02:16"
      }
    }),
    new Item("Does Torture Prevention Work?", {
      Type: { name: "Presentation", color: "primary" },
      Media: {
        platform: "vimeo",
        id: "164537172"
      },
      Metadata: {
        Description:
          "Which measures – if any – are effective in reducing the risk of torture and other ill-treatment? This is the overall question of the forthcoming book “Does Torture Prevention Work?” The book is the result of a three-year research project, commissioned by the APT, and carried out independently under the lead of Dr Richard Carver, Oxford Brookes University, UK. In this interview, Dr Richard Carver and Dr Lisa Handley discuss the main findings and some of the methodological issues they faced in carrying out the research.",
        Source: "APT Geneva",
        "Source Link": "https://vimeo.com/164537172",
        Duration: "04:52"
      }
    }),
    new Item(
      "Women in Detention: putting the Bangkok Rules into practice (e-course)",
      {
        Type: { name: "Training", color: "#4caf50" },
        Media: {
          platform: "custom_picture",
          id: "/women-training.jpg"
        },
        Metadata: {
          Description:
            "Who are the women in prison – what are their backgrounds, how did they end up in prison? How does prison impact women differently than men? Why do women prisoners have higher rates of mental health issues? How can prisons respond to these? These are some of the questions that PRI’s free e-course on women in detention addresses. It is designed to assist practitioners in applying international standards and best practice. The course combines analysis of the Rules, interactive assessments and application of the Rules to real life situations, with a certificate issued on completion. It consists of ten modules which take the learner through key themes. Got more information see https://www.penalreform.org/resource/women-detention-putting-bangkok-rules-practice/ .",
          Source: "PRI / Human Rights Education Associates",
          "Source Link":
            "https://www.penalreform.org/resource/women-detention-putting-bangkok-rules-practice/",
          Date: "2013"
        }
      }
    ),
    new Item("Terrorism", {
      Type: { name: "Presentation", color: "primary" },
      Media: {
        platform: "youtube",
        id: "5BtcEEzxeiQ"
      },
      Metadata: {
        Description:
          "Part of the the COURTalks-disCOURs series, this video offers a twenty-five-minute talk by a lawyer from the Registry of the European Court of Human Rights (http://www.echr.coe.int) and was recorded in the Court’s main hearing room. It provides an overview of the Court’s jurisprudence in matters related to terrorism. It is principally aimed at legal professionals and civil society organisations. The video was produced by the Court in cooperation with, and with the support of, the Council of Europe’s Programme “Human Rights Education for Legal Professionals” (HELP; http://www.coe.int/help).",
        Source: "The COURTalks-disCOURs",
        "Source Link":
          "https://www.youtube.com/watch?v=5BtcEEzxeiQ&feature=youtu.be",
        Date: 2016,
        Duration: "24:58"
      }
    }),
    new Item(
      "Rehabilitation for victims of torture: Restoring their Humanity",
      {
        Type: { name: "Film", color: "#00bcd4" },
        Media: {
          platform: "youtube",
          id: "JlQ6fFio3vc"
        },
        Metadata: {
          Description:
            "Rehabilitation for victims of torture: Restoring their Humanity” is a short film, produced by the Convention against Torture Initiative and True Heroes Films, depicting the experiences of torture, trauma and recovery. Vincent Cochetel was kidnapped at gunpoint near Chechnya in 1998, while working for the United Nations. He was violently interrogated and abused by his captors, and held in near complete darkness for 317 days, before being released. He explains – in his own words – his long yet powerful road to recovery.",
          Source: "CTI Videos & Short Films",
          "Source Link": "https://www.cti2024.org/en/cti-videos-short-films/",
          People: "Vincent Cochetel",
          Date: "26 June 2016",
          Duration: "7:44"
        }
      }
    )
  ],
  home: [
    new Item("APT – Association for the Prevention of Torture", {
      Type: {
        name: "Organization",
        color: "#673AB7"
      },
      Metadata: {
        Website: "https://www.apt.ch/",
        Location: "Switzerland, Geneva",
        loc: [[6.1432, 46.2044]]
      }
    }),
    new Item(
      "Rehabilitation for victims of torture: Restoring their Humanity",
      {
        Type: { name: "Film", color: "#00bcd4" },
        Media: {
          platform: "youtube",
          id: "JlQ6fFio3vc"
        },
        Metadata: {
          Description:
            "Rehabilitation for victims of torture: Restoring their Humanity” is a short film, produced by the Convention against Torture Initiative and True Heroes Films, depicting the experiences of torture, trauma and recovery. Vincent Cochetel was kidnapped at gunpoint near Chechnya in 1998, while working for the United Nations. He was violently interrogated and abused by his captors, and held in near complete darkness for 317 days, before being released. He explains – in his own words – his long yet powerful road to recovery.",
          Source: "CTI Videos & Short Films",
          "Source Link": "https://www.cti2024.org/en/cti-videos-short-films/",
          People: "Vincent Cochetel",
          Date: "26 June 2016",
          Duration: "7:44"
        }
      }
    ),
    new Item(
      "Meeting with NGOs from around the world how to fight torture amid greater threats to human rights",
      {
        Type: {
          name: "Project/Activity",
          color: "#c570d4"
        },
        Metadata: {
          Description:
            "High-ranking officials such as the United Nations High Commissioner for Human Rights, the Director of the European Union’s Fundamental Rights Agency, and the Head of Switzerland’s Human Security Division, as well as some 100 human rights experts, advocacy specialists, and members of OMCT’s SOS-Torture network of NGOs from all over the world exchanged views on issues ranging from the refugee crisis to innovative methods of reporting torture.",
          Website: "http://www.omct.org/assistance-to-victims...",
          Location: "Geneva, Switzerland",
          Date: "23 September 2014",
          organisation: "OMCT",
          loc: [[6.1432, 46.2044]]
        }
      }
    )
  ]
};

export default data;



// WEBPACK FOOTER //
// ./src/Containers/AOT/data.js